// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimIncentiveCustomer = t.struct({
    customerName: t.String,
    email: t.String
}, {
    name: 'ClaimIncentiveCustomer',
    strict: true
});

export const getDefaultState = () => new ClaimIncentiveCustomer({
    customerName: '',
    email: ''
});

export default ClaimIncentiveCustomer;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-incentive-customer.js